import { ApiError } from '../api-error';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const mapApiErrorResponse = (error: any): ApiError => ({
  message: error?.message,
  status: error?.status,
  statusText: error?.statusText,
});
